<template>
  <div>
    <v-row justify="center">
      <v-col>
        <ContactsCard :items="contacts" />
      </v-col>
      <template>
        <v-col>
          <BalanceCard
            :balance="balance"
            :recommended-item="recommendedPackage"
            :has-positive-balance="isPositiveBalance"
          />
        </v-col>
      </template>
    </v-row>
    <v-row>
      <v-col>
        <Services />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <Products />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <Invoices />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <Packages />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import ContactsCard from "./ContactsCard.vue";
import BalanceCard from "./BalanceCard.vue";
import Services from "./Services/Services.vue";
import Products from "./Products/Products.vue";
import Invoices from "./Invoices/Invoices.vue";
import Packages from "./Packages/Packages.vue";

import { mapActions, mapState, mapGetters } from "vuex";

export default {
  components: {
    ContactsCard,
    BalanceCard,
    Services,
    Products,
    Invoices,
    Packages,
  },
  computed: {
    ...mapState("client", [
      "contacts",
      "balance",
      "lastInvoice",
      "recommendedPackage",
    ]),
    ...mapGetters("client", ["isPositiveBalance"]),
  },
  async created() {
    const asyncActions = [
      this.getContacts(),
      this.getBalance(),
      this.getLastInvoice(),
      this.getServices(),
      this.getProducts(),
    ];
    await Promise.allSettled(asyncActions);
  },
  methods: {
    ...mapActions("client", [
      "getContacts",
      "getBalance",
      "getLastInvoice",
      "getServices",
      "getProducts",
    ]),
  },
};
</script>